import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useDashboardStore } from "@/stores";
import { Loader2 } from "lucide-react";
import { useState } from "react";

interface NotEnoughMilesDialogProps {
  followUpEmail: () => Promise<void>;
}

export const NotEnoughMilesDialog = ({
  followUpEmail,
}: NotEnoughMilesDialogProps) => {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const program = useDashboardStore((state) => state.program);

  if (!program) {
    return null;
  }

  const handleFollowUpEmail = async () => {
    setIsLoading(true);
    await followUpEmail();
    setIsLoading(false);
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(newOpen) => {
        setOpen(newOpen);
      }}
    >
      <DialogTrigger asChild>
        <Button variant="link" className="font-semibold">
          I don't have enough miles - give me more time
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md rounded-sm max-h-screen overflow-auto">
        <div className="flex flex-col gap-6">
          <DialogTitle className="text-xl font-semibold flex gap-2 items-center">
            <div className="bg-black w-fit p-2 rounded-sm">
              <img
                src="/dashboard/emailPopup/thinking.svg"
                alt="thinking"
                className="h-full w-full"
              />
            </div>
            Don't have enough miles to complete the quote?
          </DialogTitle>
          <div className="flex flex-col gap-4">
            <Button
              onClick={handleFollowUpEmail}
              variant="secondary"
              className="w-full rounded-sm"
              disabled={isLoading}
            >
              {isLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
              Follow up in 2-3 months
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
